import { COOKIE_LIST_VERSION } from '@/constants/cookie-registry'
import { readConsentState } from './state'

export const CONSENT_LIFETIME_MONTHS = 6
export const CONSENT_MAX_LIFETIME_MONTHS = 12

function addMonths(date, months) {
  const result = new Date(date.getTime())
  result.setMonth(result.getMonth() + months)
  return result
}

export function computeOptimisticExpiry(from) {
  const base = from || new Date()
  const months = Math.min(CONSENT_LIFETIME_MONTHS, CONSENT_MAX_LIFETIME_MONTHS)
  return addMonths(base, months).toISOString()
}

export function needsReConsent(state) {
  if (!state || !state.cookieListVersion) return false
  return state.cookieListVersion !== COOKIE_LIST_VERSION
}

export function shouldShowBanner(state) {
  const current = state === undefined ? readConsentState() : state

  if (!current) return true
  if (current.isExpired) return true
  return needsReConsent(current)
}
